import "./PareklisiaResidenceRenovation.module.css";
import Header from "@/reusable_sections/Header";
import ProjectDetails from "./sections/ProjectDetails";
import ProjectHeroImage from "./sections/ProjectHeroImage";
import MainContent from "./sections/MainContent";
import Footer from "@/reusable_sections/Footer";
export default function PareklisiaResidenceRenovationPage() {
  return <div>
      <Header />
      <ProjectHeroImage />  
      <MainContent />
      <Footer />
    </div>;
}